// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._24Oub991d3oKOM1SWZ5Ed2 {\n  line-height: 0;\n}\n\n._3v3swIgQKm-xCu42UBmOF3 {\n  display: inline-block;\n  height: 4px;\n  width: 48px;\n  margin-right: 3px;\n  background-color: #E5E5E5;\n  border-radius: 31px;\n}\n\n._3v3swIgQKm-xCu42UBmOF3._2-Fk2MEU3FcvJAdiz_jhTO {\n  background-color: #2EB6C8;\n}\n\n.dMdUBbK1z7ODe0h8nID8L {\n  display: inline-block;\n  margin-top: 8px;\n  line-height: 16px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.25px;\n  text-transform: uppercase;\n  color: #777679;\n  -webkit-font-smoothing: antialiased;\n}", ""]);
// Exports
exports.locals = {
	"progressItemContainer": "_24Oub991d3oKOM1SWZ5Ed2",
	"progressItem": "_3v3swIgQKm-xCu42UBmOF3",
	"active": "_2-Fk2MEU3FcvJAdiz_jhTO",
	"title": "dMdUBbK1z7ODe0h8nID8L"
};
module.exports = exports;
